module.exports = __webpack_public_path__ + "img/badge-type-b.02186776.svg";